export default __webpack_public_path__ + "static/media/plus-step7.d365cc88.svg";